import { render, staticRenderFns } from "./Siren.vue?vue&type=template&id=778f7958&scoped=true"
import script from "./Siren.vue?vue&type=script&lang=js"
export * from "./Siren.vue?vue&type=script&lang=js"
import style0 from "./Siren.vue?vue&type=style&index=0&id=778f7958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f7958",
  null
  
)

export default component.exports